/**
 * Use apiClient and create async functions to expose API server calls.
 * Refer to https://github.com/infinitered/apisauce for more information
 * Example:
 *    export const getEntity = () => apiClient.post<EntityType>('/endpoint', payload);
 */

/* eslint-disable @typescript-eslint/no-unused-vars */
import { createApi, createApiMock, notification, storage } from '@digital/ui';
import { appConfig } from '../../helpers/appConfig';
import { onRefreshToken } from '../auth';
import mockApi from './mock';

const { baseURL, enableMock, apiURL } = appConfig;

const environment = process.env.NODE_ENV || '';

let mockConfig;

if (environment === 'development') {
  mockConfig = enableMock ? createApiMock(mockApi) : undefined;
}

/**
 * Mocked APIs are enabled only for development environment.
 */
export const apiClient = createApi({
  baseURL: `${baseURL}${apiURL}`,
  mockConfig,
  withCredentials: true
});

export const apiClientBackground = createApi({
  baseURL: `${baseURL}${apiURL}`,
  mockConfig,
  withCredentials: false
});

apiClient.addRequestTransform(request => {
  if (!request.headers) request.headers = {};
  request.headers.Authorization = `Bearer ${storage.getApiToken() || localStorage.getItem('token-sales_portal')}`;
});

apiClient.addResponseTransform(response => {
  const { ok, data } = response;
  if (!ok && !enableMock) {
    if (data && data.refresh) {
      notification.destroy();
      onRefreshToken();
    }
  }
});

apiClientBackground.addResponseTransform(response => {
  const { ok, data } = response;
  if (!ok && !enableMock) {
    if (data && data.refresh) {
      notification.destroy();
      onRefreshToken();
    }
  }
});